import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services/authService";

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    try {
      const { user } = await login(email, password);
      // якщо батьківський компонент підписаний
      onLogin?.();
      // куди редиректити після успіху
      navigate("/dashboard");
    } catch (err) {
      console.error("Помилка логіну:", err);
      // Безпечно показуємо повідомлення
      setError(
        err?.message === "LOGIN_BAD_CREDENTIALS"
          ? "Невірний email або пароль"
          : "Сталася помилка при вході"
      );
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F0E6]">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-lg shadow-md w-full max-w-sm border border-[#D2B48C]"
      >
        <h2 className="text-2xl font-bold mb-6 text-center text-[#4B2E2B]">
          Вхід
        </h2>

        {error && <div className="text-red-500 mb-2">{error}</div>}

        <div className="mb-4">
          <label className="block mb-1">Email</label>
          <input
            type="email"
            className="border rounded w-full p-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
            inputMode="email"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Пароль</label>
          <input
            type="password"
            className="border rounded w-full p-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-[#4B2E2B] text-white py-2 rounded hover:bg-[#3A2422]"
        >
          Увійти
        </button>
      </form>
    </div>
  );
}

